const Clb2007d = {
    continuo: false,
    imprimirorientacoes: true,
    usoposologiapadrao: true,
    orientacoes: "Tomar sempre de estômago cheio.",
    apresentaco: {
        descricao: "200 mg Cap Dura",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Celecoxibe",
        nomescomerciais: [
            {
                nomefantasia: "Celebra",
            },
            {
                nomefantasia: "Dicoxibe",
            },
            {
                nomefantasia: "Foxis",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 cápsula de 12 em 12 horas por 7 dias.",
        quantidade: "1",
        forma: "caixa",
    }
}

const Clb10010d = {
    continuo: false,
    imprimirorientacoes: true,
    usoposologiapadrao: true,
    orientacoes: "Tomar sempre de estômago cheio.",
    apresentaco: {
        descricao: "100 mg Cap Dura",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Celecoxibe",
        nomescomerciais: [
            {
                nomefantasia: "Celebra",
            },
            {
                nomefantasia: "Foxis",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 cápsula de 12 em 12 horas por 10 dias.",
        quantidade: "2",
        forma: "caixas",
    }
}

// const Clb10014d = {
//     continuo: false,
//     imprimirorientacoes: true,
//     usoposologiapadrao: true,
//     orientacoes: "Tomar sempre de estômago cheio.",
//     apresentaco: {
//         descricao: "100 mg Cap Dura",
//         uso: "uso interno",
//     },
//     medicamento: {
//         farmaco: "Celecoxibe",
//         nomescomerciais: [
//             {
//                 nomefantasia: "Celebra",
//             },
//             {
//                 nomefantasia: "Dicoxibe",
//             },
//             {
//                 nomefantasia: "Foxis",
//             },
//         ]
//     },
//     posologia: {
//         posologia: "Tomar 01 cápsula de 12 em 12 horas por 14 dias.",
//         quantidade: "2",
//         forma: "caixas",
//     }
// }

const DF7d = {
    continuo: false,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "5mg + 125 mg Comp Rev",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Ciclobenzaprina com Lisina",
        nomescomerciais: [
            {
                nomefantasia: "Dolamin Flex",
            },
            {
                nomefantasia: "MiogesicLis",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 comprimido a noite por 7 dias.",
        quantidade: "1",
        forma: "caixa",
    }
}

// const Cz7d = {
//     continuo: false,
//     imprimirorientacoes: false,
//     usoposologiapadrao: true,
//     orientacoes: "",
//     apresentaco: {
//         descricao: "5mg mg Comp Rev",
//         uso: "uso interno",
//     },
//     medicamento: {
//         farmaco: "Ciclobenzaprina",
//         nomescomerciais: [
//             {
//                 nomefantasia: "Miosan",
//             },
//             {
//                 nomefantasia: "Cizax",
//             },
//         ]
//     },
//     posologia: {
//         posologia: "Tomar 01 comprimido a noite por 7 dias.",
//         quantidade: "1",
//         forma: "caixa",
//     }
// }

// const NslPtz = {
//     continuo: true,
//     imprimirorientacoes: true,
//     usoposologiapadrao: true,
//     orientacoes: "",
//     apresentaco: {
//         descricao: "100 mg + 20mg Comp",
//         uso: "uso interno",
//     },
//     medicamento: {
//         farmaco: "Nimesulina + Pantoprazol",
//         nomescomerciais: [
//             {
//                 nomefantasia: "Nivux",
//             },
//             {
//                 nomefantasia: "Nidue",
//             },
//         ]
//     },
//     posologia: {
//         posologia: "Tomar 01 comprimido de 12 em 12 horas por 7 dias.",
//         quantidade: "1",
//         forma: "caixa",
//     }
// }

const Beta = {
    continuo: false,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "6,43 + 2,63mg Inj",
        uso: "uso externo",
    },
    medicamento: {
        farmaco: "Betametasona",
        nomescomerciais: [
            {
                nomefantasia: "Diprospam",
            },
            {
                nomefantasia: "Duoflan",
            },
        ]
    },
    posologia: {
        posologia: "Aplique 01 ampola intra-muscular (glúteo) profundo dose única.",
        quantidade: "1",
        forma: "ampola",
    }
}

const ETC90SN = {
    continuo: false,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "Tomar sempre de estômago cheio.",
    apresentaco: {
        descricao: "90mg Comp Rev",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Etoricoxibe",
        nomescomerciais: [
            {
                nomefantasia: "Arcoxia",
            },
            {
                nomefantasia: "Ecoxe",
            },
            {
                nomefantasia: "Xumer",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 comprimido uma vez ao dia se dor.",
        quantidade: "1",
        forma: "caixa",
    }
}

const ETC907d = {
    continuo: false,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "Tomar sempre de estômago cheio.",
    apresentaco: {
        descricao: "90mg Comp Rev",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Etoricoxibe",
        nomescomerciais: [
            {
                nomefantasia: "Arcoxia",
            },
            {
                nomefantasia: "Ecoxe",
            },
            {
                nomefantasia: "Xumer",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 comprimido uma vez ao dia por 7 dias.",
        quantidade: "1",
        forma: "caixa",
    }
}

const ETC6010d = {
    continuo: false,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "Tomar sempre de estômago cheio.",
    apresentaco: {
        descricao: "60mg Comp Rev",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Etoricoxibe",
        nomescomerciais: [
            {
                nomefantasia: "Arcoxia",
            },
            {
                nomefantasia: "Ecoxe",
            },
            {
                nomefantasia: "Xumer",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 comprimido uma vez ao dia por 10 dias.",
        quantidade: "1",
        forma: "caixa",
    }
}

const DFZ30 = {
    continuo: false,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "30mg Comp",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Deflazacorte",
        nomescomerciais: [
            {
                nomefantasia: "Calcort",
            },
            {
                nomefantasia: "Deflanil",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 comprimido pela manhã por 7 dias, então\n" +
            "tome 1/2 (meio) comprimido pela manhã mais 7 dias, então pare.",
        quantidade: "1",
        forma: "caixa",
    }
}

const DFZ75 = {
    continuo: false,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "7,5mg Comp",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Deflazacorte",
        nomescomerciais: [
            {
                nomefantasia: "Calcort",
            },
            {
                nomefantasia: "Deflanil",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 02 comprimidos pela manhã por 7 dias, então\n" +
            "tome 1 comprimido pela manhã por mais 7 dias, então PARE.\n" +
            "Caso não encontre de 7,5mg (preferível), então usar o de 6mg.",
        quantidade: "1",
        forma: "caixa",
    }
}

const Tmdsn = {
    continuo: false,
    imprimirorientacoes: true,
    usoposologiapadrao: true,
    orientacoes: "Essa medicação pode causar sonolência e diminuição dos reflexos.",
    apresentaco: {
        descricao: "50 mg Cap Dura",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Tramadol",
        nomescomerciais: [
            {
                nomefantasia: "Tramal",
            },
            {
                nomefantasia: "Tramadon",
            },
            {
                nomefantasia: "Novotram",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 cápsula de 8 em 8 horas se dor.",
        quantidade: "1",
        forma: "caixa",
    }
}

// const GliCon = {
//     continuo: true,
//     imprimirorientacoes: false,
//     usoposologiapadrao: true,
//     orientacoes: "",
//     apresentaco: {
//         descricao: "1,5+1,2g Pó Sol",
//         uso: "uso interno",
//     },
//     medicamento: {
//         farmaco: "Glicosamina + Condroitina",
//         nomescomerciais: [
//             {
//                 nomefantasia: "CondroFlex",
//             },
//             {
//                 nomefantasia: "Artrolive",
//             },
//         ]
//     },
//     posologia: {
//         posologia: "Colocar o conteúdo de um envelope em um copo de água.\nAguardar 3 minutos, então mexer com um colher.\nTomar a mistura uma vez ao dia por 6 meses.",
//         quantidade: "",
//         forma: "",
//     }
// }

const UciiHaMsm = {
    continuo: true,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "40mg + 150mg + 900mg Cáp",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Colágeno tipo II não desnaturado + Ácido hialurônico + Metilsulfonilmetano",
        nomescomerciais: [
            {
                nomefantasia: "Colaten FORCE, Motilex HA ou Colflex HIALU",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 cápsula uma vez ao dia por 6 meses.",
        quantidade: "1",
        forma: "caixa",
    }
}

const UciiArtro = {
    continuo: true,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "1,7g Comp",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Colágeno tipo II não desnaturado + Glicosamina + Curcumina + Vitaminas",
        nomescomerciais: [
            {
                nomefantasia: "Colaten Artro",
            },
        ]
    },
    posologia: {
        posologia: "Tomar 01 comprimido uma vez ao dia por 6 meses.",
        quantidade: "1",
        forma: "caixa",
    }
}

const Pdn405d204d = {
    continuo: false,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "40 mg Comp",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Prednisolona",
        nomescomerciais: [
            {
                nomefantasia: "Predsim",
            },
        ]
    },
    posologia: {
        posologia: "Tome 01 comprimido pela manhã por 5 dias, então\ntome 1/2 (meio) comprimido pela manhã por 4 dias, então pare.",
        quantidade: "1",
        forma: "caixa",
    }
}

const TmdPct = {
    continuo: false,
    imprimirorientacoes: false,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "37,5mg+325mg Comp",
        uso: "uso interno",
    },
    medicamento: {
        farmaco: "Tramadol + Paracetamol",
        nomescomerciais: [
            {
                nomefantasia: "Ultracet",
            },
            {
                nomefantasia: "Novotram Par",
            },
            {
                nomefantasia: "Revange",
            },
        ]
    },
    posologia: {
        posologia: "Tome 01 comprimido de 8 em 8 horas se dor.",
        quantidade: "1",
        forma: "caixa",
    }
}

const AINHTopico = {
    continuo: false,
    imprimirorientacoes: true,
    usoposologiapadrao: true,
    orientacoes:
        "Lave suas mãos após cada aplicação para evitar " +
        "contatos acidentais com a boca e olhos, a menos que as mãos " +
        "sejam a área em tratamento.",
    apresentaco: {
        descricao: "23,2 mg/g",
        uso: "uso externo",
    },
    medicamento: {
        farmaco: "Diclofenaco dietilamônio",
        nomescomerciais: [
            {
                nomefantasia: "Cataflam XT Emulgel",
            },
        ]
    },
    posologia: {
        posologia: "Aplique uma fina camada na região afetada de 12 em 12 horas por pelo menos três semanas.",
        quantidade: "1",
        forma: "Tubo",
    }
}

const DexaCitoNFF = {
    continuo: false,
    imprimirorientacoes: true,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "100mg + 100mg + 5mg + 437mg",
        uso: "uso externo",
    },
    medicamento: {
        farmaco: "Dexametasona + Tiamina + Piridoxina + Cianocobalamina",
        nomescomerciais: [
            {
                nomefantasia: "Dexa-Citoneurin NFF",
            },
        ]
    },
    posologia: {
        posologia:
            "Aplicar um dose (ampola I e II) por via intramuscular profunda (glúteo) " +
            "uma vez por semana por três semanas consecutivas.",
        quantidade: "1",
        forma: "caixa",
    }
}

const Cito5000 = {
    continuo: false,
    imprimirorientacoes: true,
    usoposologiapadrao: true,
    orientacoes: "",
    apresentaco: {
        descricao: "100mg + 100mg + 5000mcg ",
        uso: "uso externo",
    },
    medicamento: {
        farmaco: "Tiamina + Piridoxina + Cianocobalamina",
        nomescomerciais: [
            {
                nomefantasia: "Cronobê Complex",
            },
        ]
    },
    posologia: {
        posologia:
            "Aplicar um dose (ampola) por via intramuscular profunda (glúteo) " +
            "uma vez por semana por três semanas consecutivas.",
        quantidade: "1",
        forma: "caixa",
    }
}

export const prescricoeslist = {
    DF7d: DF7d,
    Clb2007d: Clb2007d,
    Clb10010d: Clb10010d,
    ETC90SN: ETC90SN,
    ETC907d: ETC907d,
    ETC6010d: ETC6010d,
    DFZ75: DFZ75,
    DFZ30: DFZ30,
    Beta: Beta,
    TmdPct: TmdPct,
    Tmdsn: Tmdsn,
    UciiHaMsm: UciiHaMsm,
    UciiArtro: UciiArtro,
    Pdn405d204d: Pdn405d204d,
    AINHTopico: AINHTopico,
    DexCitoNFF: DexaCitoNFF,
    Cito5000: Cito5000,
    default: {}
}

export const PrescricoesList = (presc) => {
    return prescricoeslist[presc] || prescricoeslist.default
}